// extracted by mini-css-extract-plugin
export var background = "b9_gS";
export var body = "b9_gr";
export var button = "b9_cc";
export var card = "b9_cG";
export var content = "b9_V";
export var footer = "b9_gT";
export var header = "b9_gR";
export var subtitle = "b9_gw";
export var title = "b9_br";